'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isString = require('is-string');

var isNumber = require('is-number-object');

var isBoolean = require('is-boolean-object');

var isSymbol = require('is-symbol');

var isBigInt = require('is-bigint'); // eslint-disable-next-line consistent-return


module.exports = function whichBoxedPrimitive(value) {
  // eslint-disable-next-line eqeqeq
  if (value == null || _typeof(value) !== 'object' && typeof value !== 'function') {
    return null;
  }

  if (isString(value)) {
    return 'String';
  }

  if (isNumber(value)) {
    return 'Number';
  }

  if (isBoolean(value)) {
    return 'Boolean';
  }

  if (isSymbol(value)) {
    return 'Symbol';
  }

  if (isBigInt(value)) {
    return 'BigInt';
  }
};